export default "/images/closee.svg?2362ba1cd44436dab11a5b655507a25c";